module.exports = __webpack_public_path__ + "static/img/rest31.8e45417.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rest31.jpg
// module id = d9l1
// module chunks = 0